import React from 'react';

import clsx from 'classnames';
import { Card as MuiCard } from '@mui/material';
import { makeStyles } from '@mui/styles';

const P100ReviewForAccuracy = () => {
  const classes = useStyles();

  return (
    <MuiCard style={{ marginBottom: '2rem' }}>
      <div className="flex--spaced">
        <h3 className={clsx('contrast-text', classes.miniheading)}>
          Your agent has reviewed and updated your account information, please
          review for accuracy.
        </h3>
      </div>
    </MuiCard>
  );
};

const useStyles = makeStyles(({ config }) => ({
  miniheading: {
    fontWeight: config.weights.normal,
    fontSize: config.textSizes.canon,
    paddingLeft: '2.083rem',
    marginBottom: '0.75rem',
    marginTop: '0.75rem',
  },
}));

export default P100ReviewForAccuracy;
